module.exports = __webpack_public_path__ + "static/img/5-EN-old.e2e6ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/5-EN-old.png
// module id = TaPP
// module chunks = 1